import { useEffect, useRef } from 'react';

const useScrollToTop = (dependencyArray) => {
    const ref = useRef();

    useEffect(() => {
        if (ref && ref.current) {
            ref.current.scrollTop = 0;
        }
    }, [...dependencyArray]);

    return ref;
};

export default useScrollToTop;
